// extracted by mini-css-extract-plugin
export default {"adsListBlockWrapper":"adsListBlock_adsListBlockWrapper__maEJp","adsListDL":"adsListBlock_adsListDL__1DUzs"};